import { MuiFormGroup } from '@/features/shared/material-ui';
import React, { memo } from 'react';
import { areEqual } from 'react-window';

const MarketoOptions = ({ options, theme, onChange, classes, MarketoControlFn, error }: any) => {
  return (
    <>
      {options.length === 1 ? (
        <MarketoControlFn
          theme={theme}
          type={options[0].type}
          value={options[0].value}
          attributes={options[0].attributes}
          label={options[0].label}
          checked={options[0].checked}
          disabled={options[0].disabled}
          classes={classes}
          onChange={onChange}
          error={error}
        />
      ) : (
        <MuiFormGroup>
          {options.map((option: any, idx: number) => (
            <MarketoControlFn
              theme={theme}
              key={option?.value || `control_${idx}`}
              type={option.type}
              value={option.value}
              attributes={option.attributes}
              label={option.label}
              checked={option.checked}
              disabled={option.disabled}
              classes={classes}
              onChange={onChange}
              error={error}
            />
          ))}
        </MuiFormGroup>
      )}
      {!!error && <p className="Mui-error-text small">{error}</p>}
    </>
  );
};

export default memo(MarketoOptions, (prevProps: any, nextProps: any) => {
  const { options: prevOptions, theme: prevTheme } = prevProps;
  const { options: nextOptions, theme: nextTheme } = nextProps;

  return areEqual(prevOptions, nextOptions) && prevTheme === nextTheme;
});
